import platform from '@configs/index.js'
import base from './base.js'

export function getConfigs() {
  return {
    ...base,
    ...platform,
  }
}
